<template>
  <div class="container">
    <div class="row pt-3 pl-3 pr-3">
      <div class="col-12">
        <div id="skeleton-form">
          <div class="row">
            <div class="col-12">
              <b-skeleton type="text" animation="wave" width="50%"></b-skeleton>
              <b-skeleton type="input" animation="wave"></b-skeleton>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <b-skeleton type="text" animation="wave" width="60%"></b-skeleton>
              <b-skeleton type="input" animation="wave"></b-skeleton>
            </div>
            <div class="col-6">
              <b-skeleton type="text" animation="wave" width="60%"></b-skeleton>
              <b-skeleton type="input" animation="wave"></b-skeleton>
            </div>
          </div>
        </div>

        <form id="cardForm">
          <div class="row mb-2" v-if="ccData.length > 0">
            <div class="col-12">
              <label>{{ $t('payments.USE_OLD_CARD') }}</label>
              <div class="ccContainer">
                <div v-for="cc in ccData" :key="cc.cardId" class="input-group mb-2" @click="selectCard(cc)">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <img :src="cardUsedBrandClass(cc.brand, cc.pan)" class="ccBrand" :alt="cc.brand" :title="cc.brand" />
                    </span>
                  </div>
                  <div class="form-control ccDataContent">
                    <span class="ccPan">{{ cc.pan.replaceAll("X", "*") }}</span>
                    <span class="ccExpire text-primary">{{ cc.expm }} / {{ cc.expy }}</span>
                    <span class="ccHolder">{{ cc.holder }}</span>
                  </div>
                  <div class="input-group-append">
                    <span class="input-group-text" style="background: #fff !important;">
                      <md-button class="md-icon-button md-dense md-accent" :disabled="processing" @click="selectCard(cc)">
                        <md-icon class="fas fa-check"></md-icon>
                      </md-button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="mt-3 mb-3">
                <label>{{ $t('payments.USE_NEW_CARD') }}</label>
              </div>

            </div>
          </div>

          <!--
          <div id="payment-carousel" v-show="showCarousel" class="mb-2 bg-light rounded pt-2 pb-2"></div>
          -->

          <div id="card-container">
            <div class="row">
              <div class='col-12'>
                <label>{{ $t('payments.CARD_NUMBER') }}</label>
                <div class="hostedfield" id="card-number"></div>

                <label class="mt-3">{{ $t('payments.CARD_HOLDERNAME') }}</label>
                <div class="hostedfield" id="card-holder"></div>
              </div>
            </div>
            <div class="row mt-3">
              <div class='col-6'>
                <label>{{ $t('payments.CARD_EXPIRY') }}</label>
                <div class="hostedfield" id="card-expiry"></div>
              </div>
              <div class='col-6'>
                <label>{{ $t('payments.CARD_CVV') }}</label>
                <div class="hostedfield" id="card-cvc"></div>
              </div>
            </div>
            <div class="row mt-1" v-show="cardError !== ''">
              <div class='col-12'>
                <div id="card-error-message" class="error">{{ cardError }}</div>
              </div>
            </div>
          </div>

          <!--
          <div id="alternative-container" v-show="currentPayment !== 'card'"></div>
          -->
        </form>
        <div class="justify-content-center mt-3 text-center">
          <md-button class="md-raised md-accent" id="validCardBtn" :disabled="processing" @click="process">{{ $t('payments.VALID')}}</md-button>
          <md-progress-spinner  md-mode="indeterminate" v-show="processing" class="mt-2"></md-progress-spinner>
        </div>
        <div class="justify-content-center mt-3 text-center">
          <img src="@/assets/img/secured-payment.jpg" alt="" class="d-inline-block mb-2" />
          <p class="text-body" style="font-size: 11px; line-height: normal !important;">{{ $t("payments.SECURE3D_TEXT") }}</p>
        </div>
      </div>
    </div>

    <transition name="modal">
      <div class="modal-mask" v-show="showModalCVC">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-body">
              <img src="@/assets/img/cvv.png" />
              <span class="text-muted d-inline-block mt-2"><small>{{ cvcExplain }}</small></span>
            </div>

            <div class="modal-footer">
              <md-button @click="hideCVC()">{{ $t("common.CLOSE") }}</md-button>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import isEmpty from "is-empty";
import http from "@/utils/http-common";
import paymentConfig from "@/config/payment.config";
import cryptoUtils from "@/utils/crypto";

let script;
let hipay;
export default {
  name: "CardHP",

  props: {
    params: {
      type: String,
      default: () => ""
    },

    ccData: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      processingSecure: false,
      processing: false,
      //carouselInstance: null,
      //currentPayment: 'card',
      //carouselReady: false,
      //showCarousel: false,
      cardInstance: null,
      cardType: '',
      //alternativeInstance: null,
      showModalCVC: false,
      cvcExplain: "",
      cardError: '',
      cardSave: true,
      currentCard: {pan: ''},
      validData: false,
    }
  },

  methods: {

    onScriptLoad() {
      script.setAttribute("data-status", "loaded");
      this.initialize();
    },

    onScriptError() {
      script.setAttribute("data-status", "error");
    },

    logD(message) {
      if (paymentConfig.config.hp.debug) {
        window.console.log(message);
      }
    },

    logE(error) {
      if (paymentConfig.config.hp.debug) {
        window.console.error(error);
      }
    },

    /*
      Forms methods
     */

    hideCVC() {
      this.showModalCVC = false;
    },

    cardUsedBrandClass(brand, pan) {
      let icon = '';
      brand = brand.toLowerCase() || 'unknown';
      let cardBrandToClass = {
        'visa': 'cc-visa.svg',
        'mastercard': 'cc-mastercard.svg',
        'amex': 'cc-amex.svg',
        'discover': 'cc-discover.svg',
        'diners': 'cc-diners-club.svg',
        'jcb': 'cc-jcb.svg',
        'unknown': 'credit-card.svg',
      };
      if (cardBrandToClass[brand]) {
        icon = cardBrandToClass[brand];
      }
      else {
        if (pan.startsWith("5")) {
          icon = cardBrandToClass['mastercard'];
        }
        else if (pan.startsWith("4")) {
          icon = cardBrandToClass['visa'];
        }
        else {
          icon = cardBrandToClass['unknown'];
        }
      }
      return require('@/assets/img/'+icon);
    },

    /*
      API methods
     */

    async initialize() {
      // let response;
      try {
        await http.post("payments/hpy/initialize", {
          data: this.params
        });
      } catch (error) {
        this.$toast.error(this.$t("payments.ERROR_PAYMENT_ERROR"));
        return;
      }

      const hipayConfig = {
        username: paymentConfig.config.hp.username,
        password: paymentConfig.config.hp.password,
        environment: paymentConfig.config.hp.environment,
        lang: this.$i18n.locale
      }

      hipay = window.HiPay(hipayConfig);

      /*
      const configCarousel = {
        template: 'auto',
        selector: 'payment-carousel',
        currency: response.data.result.currency,
        country: response.data.result.country,
        payment_product: ['card', 'bcmc-mobile', 'bcmc', 'ideal', 'paysafecard']
      };

      this.carouselInstance = hipay.create('carousel', configCarousel);

      this.carouselInstance.on('ready', () => {
        this.carouselReady = true;
      });

      this.carouselInstance.on('change', (event) => {
        if (this.carouselReady && !isEmpty(event.code)) {
          this.showCarousel = true;
        }

        this.currentPayment = event.code || 'card';

        if (this.currentPayment !== 'card') {
          this.cardError = "";
          const alternativeContainerElt = document.getElementById("alternative-container");
          if (alternativeContainerElt.hasAttribute("data-current-payment") && alternativeContainerElt.getAttribute("data-current-payment") === this.currentPayment) {
            return;
          }

          alternativeContainerElt.setAttribute("data-current-payment", this.currentPayment);
          let alternativeConfig = {
            selector: 'alternative-container',
            template: 'auto'
          };

          if (!isEmpty(this.alternativeInstance)) {
            this.alternativeInstance.destroy();
            this.alternativeInstance = null;
          }

          alternativeContainerElt.innerHTML = "";
          this.alternativeInstance = hipay.create(this.currentPayment, alternativeConfig);

          this.alternativeInstance.on('change', (event) => {
            this.validData = event.valid;
          });
        }
      });
      */
      const config = {
        fields: {
          cardNumber: {
            selector: 'card-number' // card number div id
          },
          cardHolder: {
            selector: 'card-holder' // card holder div id
          },
          expiryDate: {
            selector: 'card-expiry' // expiry date div id
          },
          cvc: {
            selector: 'card-cvc', // cvc div id
            helpButton: true // activate the help button
          }
        },
        styles: {
          base: {
            // default field styling
            color: '#000000',
            fontSize: '15px',
            fontWeight: 400,
            placeholderColor: '#999999',
            iconColor: '#00ADE9',
            caretColor: '#00ADE9'
          },
          invalid: {
            // invalid field styling
            color: '#D50000',
            caretColor: '#D50000'
          }
        }
      };

      try {
        this.cardInstance = hipay.create('card', config);
      } catch (error) {
        this.logE(error);
      }
      this.cardInstance.on('ready', () => {
        const skeletonElt = document.getElementById("skeleton-form");
        skeletonElt.remove();
      });

      this.cardInstance.on('helpButtonToggled', (event) => {
        if (event.element === 'cvc') {
          this.cvcExplain = event.message;
          this.showModalCVC = true
        }
      });

      this.cardInstance.on('cardTypeChange', (event) => {
        this.cardType = event;
      });

      this.cardInstance.on('change', (event) => {
        this.cardError = !isEmpty(event.error) ? event.error : '';
        this.validData = event.valid;
      });
    },

    /*
      Process methods
     */

    async selectCard(cc) {
      this.currentCard = cc;
      await this.processCard();
    },

    async processCard() {
      if (this.processing) {
        return;
      }

      this.processing = true;

      const browserInfo = hipay.getBrowserInfo();
      const deviceFingerPrint = hipay.getDeviceFingerprint();

      const paymentData = {
        token: this.currentCard.token,
        holder: this.currentCard.holder,
        expiry: this.currentCard.expm + "-" + this.currentCard.expy,
        brand: this.currentCard.brand,
        cardId: this.currentCard.cardId,
        payment_product: this.currentCard.brand,
        browser_info: browserInfo,
        device_fingerprint: deviceFingerPrint
      };
      this.sendPayment(paymentData);
    },

    async process() {
      if (this.processing || !this.validData) {
        return;
      }

      if (['bcmc','maestro'].includes(this.cardType)) {
        this.$toast.error(this.$t("payments.ERROR_PAYMENT_CARD_NOT_SUPPORTED"));
        return;
      }

      this.processing = true;

      let that = this;
      // if (this.currentPayment === 'card') {
        this.cardInstance.setMultiUse(true);
        // init
        this.cardInstance.getPaymentData().then(function (response) {
          /* Send token to your server to process payment */

          /* Samples data
          {
            "payment_product": "visa",
            "token": "f39bfaxxxxxxxxxxxxxxxxxxxa12345a67ab89",
            "request_id": "0",
            "brand": "VISA",
            "pan": "411111xxxxxx1111",
            "card_holder": "JOHN DOE",
            "card_expiry_month": "12",
            "card_expiry_year": "2021",
            "issuer": "ANY BANK",
            "country": "US",
            "card_type": "CREDIT",
            "device_fingerprint": "...",
            "browser_info": {
                "java_enabled": false,
                "javascript_enabled": true,
                "language": "fr-FR",
                "color_depth": 24,
                "screen_height": 900,
                "screen_width": 1600,
                "timezone": "-120",
                "http_user_agent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/73.0.3683.75 Safari/537.36",
                "ipaddr": "",
                "http_accept": ""
            }
          }
           */

          that.sendPayment(response);
        }, function (errors) {
          /* Display first error */
          // window.console.error(errors);
          that.cardError = errors[0].error;
          that.processing = false;
        });
      /*
      }
      else {
        this.alternativeInstance.getPaymentData().then(function(response) {

          /*
            Sample data

            IDEAL
            {
                "payment_product": "ideal",
                "issuer_bank_id": "INGBNL2A",
                "device_fingerprint": "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",
                "browser_info": {
                    "java_enabled": false,
                    "javascript_enabled": true,
                    "language": "fr-FR",
                    "color_depth": 24,
                    "screen_height": 1080,
                    "screen_width": 1920,
                    "timezone": "-120",
                    "http_user_agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/125.0.0.0 Safari/537.36",
                    "ipaddr": "",
                    "http_accept": ""
                },
                "data_id": "0473ebfbb38f4ca08814370d10734713b08f3feadd017c551be95ba7f57167bf"
            }

            PAYSAFECARD
            {
                "payment_product": "paysafecard",
                "device_fingerprint": "0400wnM5iQ9Zf/+VebKatfMjIBQprBr0MoV4z0Sl6fBMpznl9gq8yRCPOMqCyeGt6d1wSaqEx8LjrctKOCk7IR4HaZRvFCMSbl5x8bIjfUfl7gfKyr9ST1O+SCpq4/eQIAw4ZOY6osDdKdHF+TRQrIwTM8N+h7sX35VY8ylx0iHot4IETtBPG8HFJCs1owUe6bf4VnRLrFp/nDDxVajijX/olK6mKshbYcyNsEMprBuTyXLOLB6P/20DnrNmm4OrfWIQCh0zqtYmYtP9CLGvt9MklO6zG/okbZYT/pr71oD561rIN2nQUeXRXrTsNpnni11vpunY9LUnm/ROfdJx+sF9hMX5NFCsjBMzw36HuxfflVjzKXHSIei3ggRO0E8bwcUkKzWjBR7pt/hWdEusWn+cMO9RJsn4u3PdHf7WUtiodkRxolU/OLe7EnVjWk7MYNzwhj+mDodqT7tv47mN+mlXbwPvMDAMJw6HqUmseT0vx03ou/4cZn3SOBYIr8FDZyRDzyldPNrMSXofUj8gSjVuh/RgB5wVPN7WOAca2gjCSrUfsdnyjzWDMDcPBAjSWzMyqvu9/kmyrH8voakOMmmIQEBi0vlAnnmpFoEtQ9fypghUE5q/c6eAAGgpnPDLOVklPtGY0RNeKYB09ai8Rlz13wgRejCQfNDsBeiOThsX3U/xi6pRIGZHQzFHSG54Ldn1BZV3xtdJaiTsTfyl6WV/8WXPboTYuLw3mZDIcFeje7PDgLEj+NnjTkOtFBn2McHdwRFK4yxRDQZmeMQU8ov8s/3Sa4RCjJw4Eg/+p6sl8507TuArI4TTCbPgPahfzF10HJ9JnZA27z0IgLZAX23/tNO7jPppTLnFTm4xtyEtR8twBsiHD6AZXvWIfKG5WVrGex1TLARybUr4X35U0eVzPZXAAYR3cfgv3nZEBQ8rALMtAB9loDuNKLAcesNbcdJjGc+x7ZkkKyrh7d/W78RPOnlWmCRBdNDNnZsKRSTH+INxUGlPwgQLyr/g+hNe6Gv0VTw2C4oQ2p68htYyR+1KIgUITVdF834dnbURPiuFodj1gLhnJo8PBOixLXGBICA1JpQYAFUrDlfSKRv/eHV3QiboXLuw9Lm6EakrEZHPLebC8T9w11NK6kcOjS9hgMLfawE4LsFveTttrNHzt95ePpbluSG3IU3/BqVHq2r3awttdHvDhq61RgfJ/zck+QECRFofiVW6UDyBGA35nwcAWEYXN3+bqydWC1ydTmkV6SIHyf83JPkBAkRaH4lVulA8gRgN+Z8HAFhGFzd/m6snVgtcnU5pFekiB8n/NyT5AQKok7PtgJahH8JBqLj+Tz8rkAvvX5+GhXGvlcetxenoDd7uW4fKrTjGYSqEk9HYTgjgklNKGT1jRHxfYV3WeA0UPPK1E1+GGd9pLLGVQUKIYR2wTw53CiWK/XQXiHK5P5nW8k6kOYliBrI+vS3zO1UWKyNRXh0mw7Kb1x4cMpEKIrjEjVFMhgLyi4PvWoIpyZmpr5zlQx90s1eovP7W+WpQCv10TaNx+XTCCuhAF+nK4h7iE8l4UbHvAOXDaU/lbtpUgBbu4NCNc8nkpk5j7w7ZnmVsrBuRjVYuIsQnjM1OefXRsRaGVY52Ose6Otdi5satsfNGTHdxWrvbUx/xDbcMCNSZFyAesEZfmyjFtsZKWulhv70fMljF7ba/QPSXm+mzj+kxQThxK8LzL1tKkbTjgrvRJWj7dqSrLiZXH0PREV76Q6FVOD0X3rVDgosEjUCD/jcqob76leLksK0m8U6ebAuMOd+JKvFhOMA/qogOU4yTVbOS1w1FRV8flS7U9rrgRYfF/t55LxJNFs5NNIw4POYe85lXFCQsFef4pEKtYYsvZv1puiQkd0mMhGofYK8eb8JRG/ZBhfF7CXlj79gnSUpGCTU5RhA5c6TI0o6KFnQbV6jw/1e86+qdayE4rLYyWA4iiWbHrL+Xw4CDIRsS3TwFQ+nwJRybIX/bvrfb5YdgmthE0P3JAsW2N7Rc74o0dczG+AV8dpWvgoEThLjersYwBlZ28OECFasx67qvSpIVd1uGFu1MCzSFgyV6HqPswWQdwqbh2GjSWGXk8e0aGhheUyvLy26kKz4LBfzC3u7bHap7z3hslmNdgk40hamDchu+2lGv9V543P8ciZCxtdgH5rKvPh9giPIAs4qnhYafSE6QGsviTU0GbD2FfyalBwKhTZreawXvgtxT/igBa02F6IUlSsEbbLUbYUXeF4+DfbOlD5xfKYCuhzYxW0AocNGZCqhagdM4zZgiSdgR7JbVAZdMMLsZptn2tNpnAdOBcvP9NCrZSt/nl+7eE0tXxQdLpIDpeNzuMUu9emNtgsXv3VRcUOtUGC2I4nKPQt/A7X6cvu8g41/EqsWPqhPErKUFqx3sGWgXVkoOVIdeT7DbRlwZsmcBt6oKT02Q32ak6vVc3jRZ3uJrbm0+hdAlyKaTT/v74xIOGwViqQuBarXxffj4zkCbui08Iyf2NKRszJY7fIZIS1fBCSk7EnUJF44YWBfnWXQYU2FL4z1Mkc41qKQ6K0AHYYNdyOmCGfSCVHZYDAPbiQVaBlYkVlvRGkBDE0N5j3rw0ae4aC6zU3nDRIooatykrZV6LhXIsDOJ3n5q2sMj/fgWq4beK3xae97xsBqrasJZ6AZ4e9lsfg1vrhIfjzfbHEDvSm8A7IXDXFmcGK4XPW+kQxZGLXxhiNoGiuWQaw3LLV22yTpBbTKp5TorMSdeMyMmYgtq+tUWD9TFBPL0JQEKqvZ7+CP4z0WJCQY+SWM+HjELlgBJjmbkjz4O1ljqiNzIFoahF9B2TS1JincHXke4UE0XM/Lo7K0lSYfrCvbxO7J8prpkyECrRlM/F1neJK7eG1uh8e9M0MzyMoOZBt+poEpBv5BiFHBwxrkij6L3HzN3nDEfrf1Stp3i0mTWl/bkx5T1/WSMVrcbtQVd8z8cF4VyReR5NWlohwsOM0G8YrNMAUodm3sTZCBg2kpb7yDtr9MCcNRFMz/AzbxxBnjZyGbua5slINOlqnpGWNZ2PkjsMLXdWa/tKhO9WvuFw1xZnBiuF0vLHMWxnejzhZZvavy1bbU7YQsIgdxbQ3bzs/CgQjOgDqiNOKOFLb3ozdAJGMDWqcCGJsL72+8ZXjVxEawQVEedf+5Gll1G2MNlzX/ljpdWN3ab6+wqotLZ4dJtFBSNUfkIs+Ay7LkZxemFEC8nexWaHQTavs9Ov9u04KMiN1mpC3KIff5fpdgfE4nTOc6CsKFfIJzbusk2x/s7sFj+KfVcVynS31TMpuRFh51AiJmRM806WGfCfQtJrQGeUp8GZXy9CVL3eNCN91alLiVYAlLmM8JgdxjojOlT6Gr3oYNkaQZA6srfwO2xH1ZPRIwM6iaikdE2N/iBSjvzCFOfrGo=",
                "browser_info": {
                    "java_enabled": false,
                    "javascript_enabled": true,
                    "language": "fr-FR",
                    "color_depth": 24,
                    "screen_height": 1080,
                    "screen_width": 1920,
                    "timezone": "-120",
                    "http_user_agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/125.0.0.0 Safari/537.36",
                    "ipaddr": "",
                    "http_accept": ""
                },
                "data_id": "dac1c737850852ffeb722939967d2cee09c6f656e787ce68d17242c6941b1eb8"
            }



          that.sendPayment(response);
        }, function (errors) {
          window.console.error(errors);
          that.cardError = errors[0].error;
          that.processing = false;
        });
      }
       */
    },

    sendPayment(paymentData) {
      http.post("/payments/hpy/process", {
        data: this.params,
        sysId: "HPY",
        paymentData: cryptoUtils.base64Encode(JSON.stringify(paymentData)),
      })
          .then(response => {
            if (isEmpty(response.data.status) || response.data.status === false) {
              this.$toast.error(this.$t("payments.ERROR_PAYMENT_ERROR"));
              this.processing = false;
              return;
            }
            if (response.data.result.secure === true && !isEmpty(response.data.result.forwardUrl)) {
              // 3Dsecure
              this.$toast.info(this.$t("payments.PAYMENT_3DSECURE_REDIRECT"));
              setTimeout(() => {
                window.location = response.data.result.forwardUrl
              }, 500);
            }
            else {
              this.$router.replace("/payments/redirect");
            }
          })
          .catch((err) => {
            this.logE("sendPayment ERROR " + err.message);
            this.processing = false;
            this.$toast.error(this.$t("error.GLOBAL").toString());
          })
    },

  },

  unmounted() {
    if (document.head.contains(script)) {
      script.removeEventListener("load", this.onScriptLoad);
      script.removeEventListener("error", this.onScriptError);
      document.head.removeChild(script);
    }

    if (!isEmpty(this.cardInstance)) {
      this.cardInstance.destroy();
      this.cardInstance = null;
    }

    /*
    if (!isEmpty(this.carouselInstance)) {
      this.carouselInstance.destroy();
      this.carouselInstance = null;
    }

    if (!isEmpty(this.alternativeInstance)) {
      this.alternativeInstance.destroy();
      this.alternativeInstance = null;
    }
     */
  },

  mounted() {
    const src = "https://libs.hipay.com/js/sdkjs.js";
    script = document.querySelector(`script[src="${src}"]`);

    if (!script) {
      script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.setAttribute("data-status", "loading");
      document.head.append(script);
    }

    if (script.getAttribute("data-status") === "loaded") {
      this.initialize();
      return;
    }

    script.addEventListener("load", this.onScriptLoad);
    script.addEventListener("error", this.onScriptError);
  }
}
</script>

<style>
#validCardBtn {
  width: 100% !important;
  margin: auto !important;
}

#cardForm label {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #423838;
  width: 100%;
  margin-bottom: 10px !important;
}

.hostedfield {
  display: block;
  width: 100%;
  height:40px;
  font-size: 1rem;
  font-weight: 400;
  color: #495057;
  padding-left: 20px;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
}

.hostedfield iframe,
#payment-hosted iframe,
#alternative-container iframe {
  height: 100% !important;
}

#payment-carousel iframe[data-hipay-id="hostedfield-iframe"] {
  height: auto !important;
  max-height: 80px !important;
}

.hostedfield.HiPayField--empty {
  border: solid 1px #ced4da;
}

.hostedfield.HiPayField--focused {
  border: solid 1px #333333;
}

.hostedfield.HiPayField--valid {
  border: solid 1px #ced4da;
}
.hostedfield.HiPayField--invalid{
  border: solid 1px #dc3545;
}

#cardForm div.error {
  color: #dc3545;
  border-color: #dc3545;
  border-width: 2px;
  padding: 5px;
}

.ccContainer {
  max-height: 175px;
  overflow-y: auto;
  scroll-behavior: auto;
}

.ccBrand {
  width:25px;
}

.ccDataContent {
  background: #fff;
  height: auto !important;
  align-items: center;
  border-right:0 !important;
}

.ccPan {
  font-size: 12px;
  color: black;
  display: block;
}

.ccExpire {
  display: block;
  font-size: 12px;

}

.ccHolder {
  color: #666;
  font-size: 10px;
  display: block;
  margin-top: 2px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {

}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
